export const timezones = {
    default: "America/Chicago",
};
